import { makeStyles } from "..";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: "20px 16px",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      marginBottom: 24,
      padding: 0,
    },
  },
  back: {
    alignSelf: "center",
    paddingRight: 16,
    height: 24,
  },
  content: {
    flex: 1,
    minWidth: 1,
  },
  title: {
    display: "flex",
    alignItems: "center",
    minWidth: 1,
  },
  refresh: {
    paddingTop: 4,
    paddingLeft: 16,
  },
  subtitle: {
    display: "block",
    marginTop: 4,
  },
  actions: {
    display: "none",
    gap: 12,
    paddingTop: 12,
    [theme.breakpoints.up("md")]: {
      display: "flex",
      paddingTop: 0,
      paddingLeft: 20,
    },
  },
}));
